import { filterXSS } from 'xss';
import { htmlSafe } from '@ember/template';

export default function sanitize(input) {
  let sanitized = filterXSS(input, {
    whiteList: { nobr: [], b: [], u: [], br: [] },
    stripIgnoreTag: true,
  });

  return htmlSafe(sanitized);
}
